import { useCallback, useState } from 'react'

export const useModalState = (initialState = false) => {
	const [open, setOpen] = useState(initialState)
	const openModal = useCallback(() => setOpen(true), [setOpen])
	const closeModal = useCallback(() => setOpen(false), [setOpen])
	const toggleModal = useCallback(() => setOpen((prevOpen) => !prevOpen), [setOpen])
	return {
		open,
		openModal,
		closeModal,
		toggleModal,
	}
}